<template>
	<div class="rewards">
		<div class="main-title">Victory</div>
		<div class="title">Choose your reward:</div>

		<div class="cards">
			<div v-for="card in fight.rewards" class="card-wrap" :key="card.id" v-hammer:tap="() => select_reward(card)">
				<card :card="card" />
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from '@/components/game/card'
import Sounds from '@/js/sounds'

export default {
	name: 'rewards',
	props: {
		editing: { default: false }
	},
	computed: {
		...mapGetters([ 'fight' ]),
	},
	methods: {
		select_reward(card) {
			if (this.editing) {
				this.$emit('toggle')
			} else
				Sounds.play('button')
			this.$store.dispatch('select_reward', { card })
			this.$store.dispatch('init_fight')
		}
	},
	components: { Card }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.rewards
	absolute 0
	background-color dark
	padding 16px 0
	flex center center 
	flex-direction column
	transition 0.25s easeOutQuart
	&.rewards-enter
		opacity 0
		transform translateY(-40px)
	&.rewards-leave-to
		opacity 0
		transform translateY(40px)
		transition-delay 0.25s
	.main-title
		width 100%
		text-align center
		font-size 8rem
		text-transform uppercase
		// transform translateY(-64px)
	.title
		width 100%
		text-align center
		font-size 4rem
		margin 0 0 64px 0
		opacity 0.5
		// transform translateY(-56px)
	.cards
		height card_height
		width 100%
		flex center center
		.card-wrap
			width card_width
			height card_height
			margin 0 16px
			cursor pointer
			transition transform 0.15s easeOutQuart
			&:hover
				transform scale(1.1) translateY(-16px)


</style>
